// LOCAL ENDPOINT
//  const API = 'http://localhost:5000/api/v1';

// LIVE ENDPOINT
const API = process.env.REACT_APP_BASE_URL;

// change when submitting

export default API;
